import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';

const Blog: React.FC = () => {
  const [posts, setPosts] = useState<{ id: string; title: string; excerpt: string; link: string }[]>([]);

  useEffect(() => {
    // Skip the data fetch during static prerender (no backend, nothing to bake in).
    if (typeof window !== 'undefined' && window.__PRERENDER__) return;

    const fetchPosts = async () => {
      // Import firebase lazily so it ships as its own chunk and stays out of
      // the main bundle that every page loads.
      const [{ collection, getDocs }, { db }] = await Promise.all([
        import('firebase/firestore'),
        import('../firebaseConfig'),
      ]);
      const querySnapshot = await getDocs(collection(db, 'blogPosts'));
      const blogPosts = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as { id: string; title: string; excerpt: string; link: string }[];
      setPosts(blogPosts);
    };

    fetchPosts();
  }, []);

  return (
    <>
      <Helmet>
        <title>Blog | Atomic Tattoo Removal</title>
        <meta
          name="description"
          content="Explore our blog for expert insights, tips, and guides on laser tattoo removal. Learn about the process, aftercare, and more."
        />
        <meta
          name="keywords"
          content="tattoo removal blog, laser tattoo removal tips, tattoo removal process, tattoo removal aftercare"
        />
      </Helmet>
      <div className="blog-page">
        <h1>Atomic Tattoo Removal Blog</h1>
        <p>Explore expert insights, tips, and guides on laser tattoo removal.</p>
        <ul>
          {posts.map((post) => (
            <li key={post.id} style={{ marginBottom: '20px' }}>
              <h2>
                <Link to={post.link} style={{ textDecoration: 'none', color: '#0077b6' }}>
                  {post.title}
                </Link>
              </h2>
              <p>{post.excerpt}</p>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Blog;